module.exports = __webpack_public_path__ + "img/title_logo_sp.4dc2dbec.svg";